import { Box, BoxProps, ColorOptions, ModBox, TextNew, TextNewProps } from '@jfs/ui-new'
import { FlatList } from 'react-native'

import { EmType } from '../../..'
import { Dropdown } from '../../../../../components/Dropdown'
import { RenderFlatListData } from '../../CreateEntity/SelectParentEntityList/RenderItem'

interface LimitTableCompProps {
  selectedLoop: string
  loopData: any
  onLoopChange: any
  dataList: any[]
  isSearchFlow: boolean
  onRowPress: any
  selectedData: any
}

const columnSizeMapper: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
}
const createEntityColumnSizeMapper: any = {
  0: 1,
}
const headerTitles = [{ title: 'Current' }, { title: 'Previous' }, { title: 'Older' }, { title: 'Recruitment' }]
const createEntityTitles = [{ title: 'Current' }]
const getFlatListHeader = (isSearchFlow) => {
  const headers = isSearchFlow ? headerTitles : createEntityTitles
  const columnSize = isSearchFlow ? columnSizeMapper : createEntityColumnSizeMapper
  return (
    <Box {...styles.flatListHeader}>
      {headers?.map((item, index: number) => {
        return (
          <Box flex={columnSize[index] as number} ph={4} key={index}>
            <TextNew title={item?.title} {...styles.keyText} />
          </Box>
        )
      })}
    </Box>
  )
}

export const LimitTableComp = ({
  selectedLoop,
  loopData,
  onLoopChange,
  dataList,
  isSearchFlow,
  onRowPress,
  selectedData,
}: LimitTableCompProps) => {
  console.log('data=', dataList)
  return (
    <Box direction="row">
      <ModBox show={dataList?.length > 0}>
        <Box {...styles.header}>
          <Dropdown
            minWidth={168}
            label={''}
            title={''}
            value={selectedLoop}
            data={loopData}
            selectedData={onLoopChange}
          />
        </Box>
        <Box {...styles.cellContainer(false)}>
          <TextNew title={'Transaction Limit (Rs.)'} {...styles.keyText} />
        </Box>
        <Box {...styles.cellContainer(false)}>
          <TextNew title={'Exit Limit (Rs.)'} {...styles.keyText} />
        </Box>
        <Box {...styles.cellContainer(false)}>
          <TextNew title={'Transaction count'} {...styles.keyText} />
        </Box>
        <Box {...styles.cellContainer(true)}>
          <TextNew title={'Risk Score'} {...styles.keyText} />
        </Box>
      </ModBox>
      <ModBox show={dataList?.length === 0}>
        <TextNew title="No data found" color={'PRIMARY'} fontSize={16} fontWeight="BOLD" />
      </ModBox>
      <ModBox
        show={dataList?.length > 0}
        borderTopRightRadius={8}
        borderWidth={1}
        borderBottomRightRadius={8}
        borderColor="DISABLED_GREY"
        w={isSearchFlow ? '80%' : '30%'}>
        <FlatList
          data={dataList}
          ListHeaderComponent={getFlatListHeader(isSearchFlow)}
          renderItem={({ item, index }) => (
            <RenderFlatListData
              item={item}
              index={index}
              onRowPress={onRowPress}
              selectedParentData={selectedData}
              columnFlexMapper={isSearchFlow ? columnSizeMapper : { 0: 1 }}
              dataLength={dataList?.length}
              showBorder={false}
              type={isSearchFlow ? EmType.Search : EmType.createSingleEntity}
              key={index}
            />
          )}
        />
      </ModBox>
    </Box>
  )
}

const styles = {
  keyText: {
    fontSize: 12,
    color: 'BLACK_21' as ColorOptions,
    lineHeight: 21,
    fontFamily: 'jiotype-bold',
    numberOfLines: 1,
    textAlign: 'left',
  } as TextNewProps,
  header: {
    flexDirection: 'row',
    ph: 15,
    pv: 12,
    bg: 'BACKGROUND',
    borderTopLeftRadius: 8,
    borderTopWidth: 1,
    borderLeftWidth: 1,
    borderBottomWidth: 1,
    borderColor: 'DISABLED_GREY',
  } as BoxProps,
  cellContainer: (isLastItem: boolean) =>
    ({
      ph: 15,
      pv: 12,
      bg: 'BACKGROUND',
      borderBottomWidth: 1,
      borderLeftWidth: 1,
      borderColor: 'DISABLED_GREY',
      borderBottomLeftRadius: isLastItem ? 8 : undefined,
    } as BoxProps),
  flatListHeader: {
    flexDirection: 'row',
    h: 62,
    ph: 15,
    pv: 12,
    bg: 'BACKGROUND',
  } as BoxProps,
}
